import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { useContext } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import { getAnimationComponent } from './Animation.utils';
import { ChildrenPropType, ObjectPropsPropType } from '../../../../services/proptypes';
import { classNames } from '../../../../utils/classname';
import { createComponent } from '../../../foundation/services/components';
import { ON_OPTIONS } from '../../animation.constants';
import { AnimationsSettingsContext } from '../../context';
var propTypes = {
  children: ChildrenPropType,
  content: ChildrenPropType,
  className: PropTypes.string,
  on: PropTypes.oneOf(ON_OPTIONS).isRequired,
  animationName: PropTypes.string.isRequired,
  animationProps: ObjectPropsPropType
};
var defaultProps = {
  children: null,
  content: null,
  animationProps: {}
};
export default function Animation(_ref) {
  var content = _ref.content,
    children = _ref.children,
    className = _ref.className,
    on = _ref.on,
    animationName = _ref.animationName,
    animationProps = _ref.animationProps;
  var finalContent = content || children;
  var animationsContext = useContext(AnimationsSettingsContext);
  if (!_get(animationsContext, 'enabled', true)) {
    return finalContent;
  }
  var AnimationComponent = getAnimationComponent(on, animationName);
  if (_isNil(AnimationComponent)) {
    return finalContent;
  }
  var finalClassName = classNames(_defineProperty({
    animation: true
  }, className, className));
  return createComponent(AnimationComponent, _objectSpread({
    className: finalClassName,
    content: content,
    children: children
  }, animationProps || {}));
}
Animation.propTypes = propTypes;
Animation.defaultProps = defaultProps;